import React from "react";
import { Route, Routes } from "react-router-dom";
import './assets/css/tailwind.css'
import './assets/css/materialdesignicons.min.css'

import ErrorBoundary from './components/ErrorBoundary'
import { ToastProvider } from './context/ToastProvider'

import Index from './pages/index/index'
import Grid from './pages/listing/tour-grid/grid'
import TourDetailOne from './pages/listing/tour-detail/tour-detail-one'
import Aboutus from './pages/aboutus'
import UserInvoice from './pages/account/user-invoice'
import Terms from './pages/utility/terms'
import Privacy from './pages/utility/privacy'
import Error from './pages/special/404'
import Contact from './pages/contact'
import Cart from './pages/cart'
import Checkout from './pages/checkout'
import PaymentReturn from './pages/payment-return'
import ConfirmarAsistencia from './pages/ConfirmarAsistencia';

function App() {
  // Solo se rutean las páginas vivas. Las páginas de plantilla (index-two..five,
  // list*, blog*, auth, helpcenter, cuenta de usuario, etc.) se retiraron del
  // router para no exponer rutas muertas indexables; sus archivos permanecen en
  // disco pero quedan fuera del bundle al no importarse.
  // Nota: /user-invoice se preserva porque es el comprobante del flujo de compra
  // (payment-return enlaza a él con ?ref=buy_order).
  return (
    <ToastProvider>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Index/>}/>
          <Route path="/grid" element={<Grid/>}/>
          <Route path="/grid/:country" element={<Grid/>}/>
          <Route path="/tour-detail-one/:id" element={<TourDetailOne/>}/>
          <Route path="/cart" element={<Cart/>}/>
          <Route path="/checkout" element={<Checkout/>}/>
          <Route path="/payment-return" element={<PaymentReturn/>}/>
          <Route path="/user-invoice" element={<UserInvoice/>}/>
          <Route path="/confirmar/:token" element={<ConfirmarAsistencia />}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/terms" element={<Terms/>}/>
          <Route path="/privacy" element={<Privacy/>}/>
          <Route path="/aboutus" element={<Aboutus/>}/>
          <Route path="/404" element={<Error/>}/>
          <Route path="*" element={<Error/>}/>
        </Routes>
      </ErrorBoundary>
    </ToastProvider>
  );
}

export default App;
